import React from "react";
import styles from "./Slide1.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../delivery.messages";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

export const Slide1: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();
  return (
    <div className={styles.root}>
      <block.image src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/delivery/delivery1.jpg`}></block.image>
      <div className={styles.caption}>{formatMessage(messages.G4_P5_S1_Hs_PhotoCaption)}</div>
      <ul>
        <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P5_S1_Hs_Item1) }}></li>
        <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P5_S1_Hs_Item2) }}></li>
        <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P5_S1_Hs_Item3) }}></li>
        <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P5_S1_Hs_Item4) }}></li>
        <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P5_S1_Hs_Item5) }}></li>
      </ul>
    </div>
  );
};
